/* global SERVER_URL, _ */
import fetch from 'isomorphic-fetch';
import { checkHttpStatus, parseJSON } from '../utils';
import {
  CAM_GROUP_REQUEST,
  CAM_GROUP_FAILURE,
  CAM_GROUP_SUCCESS,
  FEED_SUCCESS,
  FEED_REQUEST,
  FEED_FAILURE,
  SET_CAM_GROUP_INFO,
} from '../constants';

export function camGroupSuccess(feed) {
  return {
    type: CAM_GROUP_SUCCESS,
    payload: { feed },
  };
}

export function camGroupFailure(error, message) {
  return {
    type: CAM_GROUP_FAILURE,
    payload: { status: error, statusText: message },
  };
}

export function camGroupRequest() {
  return { type: CAM_GROUP_REQUEST };
}

export function feedRequest() {
  return { type: FEED_REQUEST };
}

export function feedFailure() {
  return { type: FEED_FAILURE };
}

export function feedSuccess(groups) {
  return {
    type: FEED_SUCCESS,
    payload: { groups },
  };
}

// export function authLogoutAndRedirect() {
//   return (dispatch) => {
//     dispatch(authLogout());
//     dispatch(push('/login'));
//     return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
//   };
// }

export function fetchCamGroup(camGroupId, user) {
  return (dispatch, getState) => {
    dispatch(camGroupRequest());
    const isUser = user ? '&user=1' : '';
    const timestamp = +new Date();

    return fetch(`${SERVER_URL}/get_cam_group_info.json?t=${timestamp}&id=${camGroupId}${isUser}`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const state = getState();
        const camGroups = state.cam_groups.data;
        const index = _.findIndex(camGroups, group => group.id === response.data.id);

        if (index < 0) {
          camGroups.push(response.data);
        } else {
          camGroups.splice(index, 1, response.data);
        }

        return dispatch(camGroupSuccess(camGroups));
      })
      .catch((error, message) => {
        return dispatch(camGroupFailure(error, message));
      });
  };
}

export function fetchFeed(feedId, camGroupId) {
  return (dispatch, getState) => {
    dispatch(feedRequest());
    return fetch(`${SERVER_URL}/get_livecam_info.json?id=${feedId}`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const state = getState();
        const camgroups = state.cam_groups.data;
        const index = _.findIndex(camgroups, { id: camGroupId });
        const feedIndex = _.findIndex(camgroups[index].feeds, { id: feedId });
        const selectedFeed = camgroups[index].feeds[feedIndex];
        camgroups[index].feeds[feedIndex] = Object.assign({}, selectedFeed, response.data);
        dispatch(feedSuccess(camgroups));
      })
      .catch((err) => {
        console.error(err);
        return dispatch(feedFailure());
      });
  };
}

export function fetchLiveCamInfo(id) {
  return fetch(`${SERVER_URL}/get_livecam_info.json?id=${id}`)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.error(err);
    });
}

export function setCamGroupInfo(data) {
  return dispatch => dispatch({ type: SET_CAM_GROUP_INFO, payload: { data } });
}
